import { ErrorMessages } from "fe-shared/src/types/common";
import Joi from "fe-shared/src/helpers/validation";

export const errorMessages: ErrorMessages = {
  regYear: {
    "number.base": "validation.regYearRequired",
  },
  comment: {
    "string.empty": "validation.commentRequired",
    "string.min": "validation.commentTooShort",
    "string.max": "validation.commentTooLong",
  },
};

export interface OverrideRegYearFormContent {
  regYear: string;
  comment: string;
}

export const getInitialContent = (): OverrideRegYearFormContent => ({
  regYear: "",
  comment: "",
});

export const getValidationConfig = () => {
  return Joi.object({
    regYear: Joi.number().required(),
    comment: Joi.string().required(),
  });
};
